<template>
    <div>

        <b-modal id="create-or-update-contact-information" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <employee-contact-information-create-or-update v-model="contact" :errors="errors"></employee-contact-information-create-or-update>
            <template #modal-footer><v-executer  :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>

        <b-modal id="gsm-code" title="SMS ile Doğrulama" no-close-on-esc no-close-on-backdrop>
            <employee-sms-code v-model="sms"/>
            <template #modal-footer><v-executer :loading="verifying" :action="verify" :disabled="!smsOk">Doğrula</v-executer></template>
        </b-modal>


        <v-table    ref="table"
                    up-class="px-1 pb-1"
                    with-items
                    search
                    :items="value"
                    :add-callback="createNew"
                    :buttons="buttons"
                    name="employee_contact-İnformation"
                    overlay-class="pb-0"
                    button-alignment="justify-content-start"
                    :fields="fields"></v-table>

    </div>
</template>

<script>
import EmployeeContactInformationCreateOrUpdate from './EmployeeContactInformationCreateOrUpdate.vue'
import EmployeeSMSCode from './EmployeeSMSCode.vue';
import randomatic from 'randomatic'
import EmployeeOperationsApi from '@/api/employee-operations';
import { verify } from 'jsonwebtoken';

export default {
    components:{
        EmployeeContactInformationCreateOrUpdate,
        'employee-sms-code':EmployeeSMSCode
    },
    props:{
        value:Array,
        getPersonal:Function,
        id:[String,Number]
    },
    data(){
        return{
            fields:[
                {name:"İletişim Türü",key:"ContactTypeName",thClass:"w-50"},
                {name:"Değer",key:"Value",thClass:"w-50"},
                {name:"Doğrulandı",key:"IsVerified"},
                {name:"Varsayılan",key:"IsDefault"},
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete},
                { text:"Doğrula",key:"gsm-code",icon:"CheckCircleIcon",variant:"primary",action:this.checkGsm, condition:(i) => !i.IsVerified && i.ContactTypeKey == 'GSM' && !i.Unsaved && i.IsDefault},
            ],
            contact:{
                Id:null,
                EmployeeId:null,
                ContactTypeId:null,
                ContactTypeName:null,
                ContactTypeKey:null,
                Value:null,
                IsVerified: false,
                IsDefault:false,
            },
            sms:{
                code:''
            },
            verifying:false,
            errors:{},
            editing:false,
        }
    },
    methods:{
        clearForm(){
            this.editing = false
            this.contact.Id = null
            this.contact.EmployeeId = null
            this.contact.ContactTypeId = null
            this.contact.ContactTypeName = null
            this.contact.ContactTypeKey = null
            this.contact.Value = null
            this.contact.IsVerified = false
            this.contact.IsDefault = false
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update-contact-information')
        },
        edit(item){
            this.clearForm() 
            this.editing = true
            this.contact.Id = item.Id
            this.contact.EmployeeId = item.EmployeeId
            this.contact.ContactTypeId = item.ContactTypeId
            this.contact.ContactTypeName = item.ContactTypeName
            this.contact.ContactTypeKey = item.ContactTypeKey
            this.contact.Value = item.Value
            this.contact.IsVerified = item.IsVerified
            this.contact.IsDefault = item.IsDefault
            this.$showModal('create-or-update-contact-information')
        },
        validation(){
            let count = 0
            if(this.$isNullOrEmpty(this.contact.ContactTypeId)){
                this.$set(this.errors,'ContactTypeId','İletişim türü alanı zorunludur.')
                count ++
            }
            if(this.$isNullOrEmpty(this.contact.Value)){
                this.$set(this.errors,'Value','Değer alanı zorunludur.')
                count ++
            }
            return count > 0 ? false : true
        },
        createOrUpdate(){
            if(this.validation()){
                let id = this.contact.Id ? this.contact.Id : randomatic("A0",10)
                if(this.contact.Id){
                    let item = this.value.find(r=> r.Id == id)
                    this.$set(item,"EmployeeId",this.contact.EmployeeId)
                    this.$set(item,"ContactTypeId",this.contact.ContactTypeId)
                    this.$set(item,"ContactTypeName",this.contact.ContactTypeName)
                    this.$set(item,"ContactTypeKey",this.contact.ContactTypeKey)
                    this.$set(item,"Value",this.contact.Value)
                    this.$set(item,"IsDefault",this.contact.IsDefault)
                    this.$set(item,"IsVerified",false)
                    this.$set(item,"Unsaved",true)
                }else{
                    this.value.push({
                        Id:id,
                        EmployeeId:this.id,
                        ContactTypeId:this.contact.ContactTypeId,
                        ContactTypeName:this.contact.ContactTypeName,
                        ContactTypeKey:this.contact.ContactTypeKey,
                        Value:this.contact.Value,
                        IsDefault:this.contact.IsDefault,
                        IsVerified:false,
                        Unsaved:true
                    })
                }
                
                if(this.contact.IsDefault == true && this.contact.ContactTypeKey == 'EMAIL'){
                    this.value.filter(a=> a.Id != id && a.ContactTypeKey == 'EMAIL').forEach(a => { this.$set(a,"IsDefault",false) });
                }

                if(this.contact.ContactTypeKey == 'EMAIL') {
                    this.$emit('email-updated')
                }
    
                this.$hideModal('create-or-update-contact-information')
            }
        },
        delete(item,key,index){
            this.$confirm("Silmek istediğinize emin misiniz?",`Bu işlem iletişim bilgisini silecektir ve geri alınamaz.`).then(res=>{
                if(res){
                    this.$delete(this.value,index)
                }
                if(item.ContactTypeKey == 'EMAIL') {
                    this.$emit('email-updated')
                }
            })
        },
        checkGsm(item){
            if(item.Value){
                this.$refs.table.rowLoading(true)
                EmployeeOperationsApi.SendGSMVerification(this.id).then(res => {
                    this.$refs.table.rowLoading(false)
                    if(res.data.Success){
                        this.$showModal('gsm-code')
                    }else{
                        this.$result(res)
                    }
                }).catch(err => {
                    this.$result(null,err)
                    this.$refs.table.rowLoading(false)
                })
            }
        },
        verify(){
            this.verifying = true
            if(this.sms.code){
                EmployeeOperationsApi.VerifyGSM(this.id,this.sms.code).then(res => {
                    this.$result(res)
                    this.verifying = false
                    if(res.data.Success){
                        this.$hideModal('gsm-code')
                        this.getPersonal()
                    }
                }).catch(err => {
                    this.$result(null,err)
                    this.verifying = false
                })
            }
        }
    },
    computed:{
        smsOk(){
            return this.sms.code.split('').length == 6
        }
    }
}
</script>

<style>

</style>